// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {
    Checkbox,
    createFilterOptions,
    FormHelperText,
    Input,
    InputLabel,
    Select,
    Stack,
    TextField
} from "@mui/material";

// App Imports
import {addDataPointValue, editDataPointValue} from "./DataPointValueClient";
import {changeCrudSnackbar} from "../CommonComponents/crudSnackbarSlice";
import {changeDataPointValue} from "./dataPointValueSlice";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {getAllDataPoints} from "../DataPoint/DataPointClient";
import {Autocomplete} from "@mui/lab";
import {addDataPointAttribute} from "../DataPointAttribute/DataPointAttributeClient";


// Main Function
export default function DataPointValueDrawer({fetchDataPointValues}) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(true);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const dispatchData = useDispatch() ;
    const selectorDataPointValueId = useSelector((state) => state.dataPointValueSlc.value.id);
    const selectorDataPointId = useSelector((state) => state.dataPointValueSlc.value.dataPointId);
    const selectorDpvDrawerState = useSelector((state) => state.dataPointValueSlc.value.dpvDrawerState);
    const selectorDpvDrawerMode = useSelector((state) => state.dataPointValueSlc.value.dpvDrawerMode);
    const [exceptionFlag, setExceptionFlag] = useState(useSelector((state) => state.dataPointValueSlc.value.exceptionInd));
    const drawerModeRef = React.useRef(selectorDpvDrawerMode);

    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    const { register, handleSubmit,setValue,  control, formState: { errors } } = useForm();
    // const {register, handleSubmit} = useForm();

    // ****************** END REGISTER ****************************


    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
        setSubmitting(true)
        console.log("here's my dataPointValue data")
        console.log({data})
        console.log("here's my stringify data")
        console.log(JSON.stringify(data, null, 2))
        if(selectorDpvDrawerMode==="Add"){
            addDataPointValue(data)
                .then(() => {
                    console.log("DataPointValue added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                    // fetchDataPointValues();
                }).catch(err => {
                console.log(err);
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeDataPointValue({id: 0, dataPointId:null, mcode: null, name: null, description: null, ordinalNumber: null,exceptionInd:false,
                    status: null,createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    dpvDrawerState: false, dpvGridRefresh: true
                    }));
            })}
        if(selectorDpvDrawerMode==="Clone"){
            const { id, ...clonedData } = data; // removes id
            addDataPointValue(clonedData)
                .then(() => {
                    console.log("Data Point Value cloned");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                    // fetchDataPointValues();
                }).catch(err => {
                console.log(err);
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Clone failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeDataPointValue({id: 0, dataPointId:null, mcode: null, name: null, description: null, ordinalNumber: null,exceptionInd:false,
                    status: null,createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    dpvDrawerState: false, dpvGridRefresh: true
                }));

            })}
        if(selectorDpvDrawerMode==="Edit") {
            console.log("This is the Data Point Value Id I am going to edit")
            console.log(selectorDataPointValueId)

            editDataPointValue(selectorDataPointValueId, data)
                .then(() => {
                    console.log("DataPointValue edited")
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                    // fetchDataPointValues();
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            }).finally(() => {
                setSubmitting(false);
                // setShowDataPointValueDrawer(false);
                dispatchData(changeDataPointValue({
                    id: 0,
                    dataPointId: null,
                    mcode: null,
                    name: null,
                    description: null,
                    ordinalNumber: null,
                    exceptionInd: false,
                    status: null,
                    createdOn: null,
                    createdBy: null,
                    lastModifiedOn: null,
                    lastModifiedBy: null,
                    dpvDrawerState: false, dpvGridRefresh: true
                }));
            })
        }};

    // ****************** END CRUD ****************************




        // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };

    function closeDataPointValueDrawer() {
        // setShowDataPointValueDrawer(false);
        dispatchData(changeDataPointValue({id: 0, dataPointId:null, mcode: null, name: null, description: null, ordinalNumber: null,exceptionInd:false,
            status: null,createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
            dpvDrawerState: false}));
    };

    const filter = createFilterOptions({
        stringify: (option) => option.name || ""
    });

    // ****************** END MISC ****************************


    // ******************* BEGIN AUTOCOMPLETE *********************

    const [dataPointDropdown, setDataPointDropdown] = useState([]);
    const [dataPoints, setDataPoints] = useState([]);
    const [selectedDataPoint, setSelectedDataPoint] = useState(null);


    const fetchDataPoints = () =>
        getAllDataPoints()

            .then(data => {
                console.log(data);
                setDataPoints(data);
            })
    useEffect(() => {
        fetchDataPoints();
    }, []);

    // const handleDataPointChange = (dataPointEvent) => {
    //     setSelectedDataPoint(dataPointEvent.target.value);
    //     console.log("This is for the selected Value");
    //     console.log(dataPointEvent.target.value);
    // };


    const handleDataPointChange = (dataPointEvent) => {
        console.log("handleDataPointChange triggered by ", dataPointEvent);
        // setSelectedDataPoint(dataPointEvent);
        dispatchData(changeDataPointValue({dataPointId: dataPointEvent}));
        console.log("This is for the selected Value");
        console.log(dataPointEvent);
    };

    useEffect(() => {
        const existingValue = selectorDataPointId;
        setValue('dataPoint.id', existingValue ? existingValue : null);
    }, [selectorDataPointId, setValue]);

    // ****************** BEGIN FORM ****************************

    function dataPointValueForm(){
        return(
            <form
                onSubmit={handleSubmit((data)=>        onSubmit(data))}
            >
                <Box
                    sx={{ width: 800 , height: 300, pl: 5}}
                    role="presentation"
                >
                    <h1 onClick={() => closeDataPointValueDrawer()}>Data Point Value Form</h1>
                    <h4>{selectorDpvDrawerMode} Mode</h4>
                    <br/>
                    <br/>
                    <br/>
                    <InputLabel  htmlFor="mcode">Code</InputLabel>
                    <Input
                        {...register('mcode', { required: true })}
                        id="mcode" name="mcode"  label="mcode" aria-describedby="mcode_entry"
                        defaultValue=        {useSelector((state) => state.dataPointValueSlc.value.mcode)}

                    />
                    <FormHelperText id="mcode_helper">enter a brief code in all caps</FormHelperText>
                    <br/>
                    <br/>
                    <InputLabel htmlFor="name">Name</InputLabel>
                    <Input
                        {...register('name', { required: true })}
                        id="name"   name="name"  label="Name" aria-describedby="name_entry"
                        defaultValue=        {useSelector((state) => state.dataPointValueSlc.value.name)}
                        sx={{ width: 600 }} />
                    <FormHelperText id="name_helper">enter the name of the Data Point Value</FormHelperText>
                    <br/>
                    <br/>
                    <InputLabel htmlFor="description">Description</InputLabel>
                    <Input
                        {...register('description', { required: false })}
                        id="description" name="description"  label="description" aria-describedby="description_entry"
                        defaultValue=        {useSelector((state) => state.dataPointValueSlc.value.description)}
                        sx={{ width: 700 }}/>
                    <FormHelperText id="v_helper">enter the Description of the data Point Value</FormHelperText>
                    <br/>
                    <br/>
                    {/*<FormControl variant="standard" sx={{ m: 1, minWidth: 340 }}>*/}
                    {/*    <InputLabel htmlFor="dataPoint.id">Data Point</InputLabel>*/}
                    {/*    <Select*/}

                    {/*        {...register('dataPoint.id', { required: true })}*/}
                    {/*        labelId="dataPoint.id"*/}
                    {/*        id="dataPoint.id"*/}
                    {/*        label="dataPoint.id"*/}
                    {/*        onChange={handleDataPointChange}*/}
                    {/*        defaultValue=        {useSelector((state) => state.dataPointValueSlc.value.dataPointId)}*/}
                    {/*    >*/}
                    {/*        {dataPoints.map((DataPointItem) =>*/}
                    {/*            <MenuItem value={DataPointItem.id}>{DataPointItem.name}</MenuItem>*/}
                    {/*        )}*/}
                    {/*    </Select>*/}
                    {/*    <FormHelperText id="contractLevel_helper">select the Data Point</FormHelperText>*/}
                    {/*</FormControl>*/}
                    <Autocomplete
                        disablePortal
                        disableCloseOnBlur
                        ListboxProps={{
                            style: {
                                maxHeight: 400,  // <-- make the listbox longer
                            },
                            onClick: (event) => {
                                event.stopPropagation();
                            }
                        }}

                        labelId="dataPoint.id"
                        id="dataPointId"
                        options={dataPoints}
                        // getOptionLabel={(option) => option.name}
                        // getOptionLabel={(option) => option && option.name ? option.name : ""}
                        getOptionLabel={(option) => {
                            if (!option) return "";
                            if (typeof option === 'number' || typeof option === 'string') {
                                const found = dataPoints.find(dp => dp.id === parseInt(option));
                                return found && found.name ? found.name : "";
                            }
                            return option && option.name ? option.name : "";
                        }}
                        // filterOptions={(options, state) => {
                        //     return options.filter(option => {
                        //         const name = option && option.name ? option.name : "";
                        //         return name.toLowerCase().includes(state.inputValue.toLowerCase());
                        //     });
                        // }}
                        filterOptions={filter}
                        isOptionEqualToValue={(option, value) => option && value ? option.id === value.id : option === value}
                        // isOptionEqualToValue={(option, value) => option && value ? option.id === '999999' : option === value}
                        // isOptionEqualToValue={() => false}
                        // isOptionEqualToValue={(option, value) => option.id === value.id}
                        // isOptionEqualToValue={(option, value) =>
                        //     option && value ? option.id === value.id : option === value}
                        // defaultValue=        {useSelector((state) => state.contractDataPointSlc.value.dataPointId)}
                        // value={dataPoints.find(dp => dp.id === parseInt(selectorContractDataPointId))}
                        // value={selectorDataPointId || null}
                        value={dataPoints.find(dp => dp.id === parseInt(selectorDataPointId)) || null}
                        onChange={(event, newValue) => {
                            setSelectedDataPoint(newValue);
                            setValue('dataPoint.id', newValue ? newValue.id : null, { shouldValidate: true });
                            console.log("onChange triggered in Data Point dropddown");
                            handleDataPointChange(newValue ? newValue.id : null);
                        }}
                        onInputChange={(event, newInputValue, reason) => {
                            console.log("onInputChange triggered", newInputValue, reason);
                        }}
                        onHighlightChange={(event, option, reason) => {
                            console.log("onHighlightChange triggered", option, reason);
                        }}
                        sx={{width: 600}}
                        renderInput={(params) => <TextField {...params} label="Data Point" variant="standard"/>}
                        // ListboxComponent={ListboxComponent}
                    />
                    <br/>
                    <br/>
                    <br/>

                    <Stack direction={"horizontal" } spacing={2} >
                        <Box sx={{ width: 250, mr: 4}}>
                        <InputLabel htmlFor="ordinalNumber">Order</InputLabel>
                    <Input
                        {...register('ordinalNumber', { required: false })}
                        id="ordinalNumber" name="ordinalNumber"  label="ordinalNumber" aria-describedby="ordinalNumber_entry"
                        defaultValue=        {useSelector((state) => state.dataPointValueSlc.value.ordinalNumber)}
                        sx={{ width: 80 }}/>
                    <FormHelperText id="ordinalNumber_helper">(optional)</FormHelperText>
                        </Box>
                        <Box sx={{ width: 300}}>
                            <InputLabel htmlFor="exceptionInd">Exception</InputLabel>
                    <Checkbox
                        checked={exceptionFlag}
                        onClick = {()=> setExceptionFlag(!exceptionFlag)}
                        {...register('exceptionInd', { required: false })}
                        id="exceptionInd" name="exceptionInd"  label="exceptionInd" aria-describedby="exceptionInd_entry"
  //                      defaultValue=        {useSelector((state) => state.dataPointValueSlc.value.exceptionInd)}
                        sx={{ width: 80 }}/>
                    <FormHelperText id="exceptionInd_helper">Flag as an exception?</FormHelperText>
                        </Box>
                        </Stack>
                    <HiddenFields />
                    <Button
                        type= "submit"
                    >Submit</Button>
                    <Button onClick={() => closeDataPointValueDrawer()}>Cancel</Button>
                </Box>
            </form>
        );}

    // ****************** END FORM ****************************


    // ****************** BEGIN HIDDEN FIELDS ****************************

    function HiddenFields() {
        return (
            <div>
                <Input style={{ visibility: "hidden" }}
                       {...register('status', { required: false })}
                       id="status" name="status"  label="status" aria-describedby="status_entry"
                       defaultValue=        {useSelector((state) => state.dataPointValueSlc.value.status)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('createdOn', { required: false })}
                       id="createdOn" name="createdOn"  label="createdOn" aria-describedby="createdOn_entry"
                       defaultValue=        {useSelector((state) => state.dataPointValueSlc.value.createdOn)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('createdBy', { required: false })}
                       id="createdBy" name="createdBy"  label="createdBy" aria-describedby="createdBy_entry"
                       defaultValue=        {useSelector((state) => state.dataPointValueSlc.value.createdBy)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('lastModifiedOn', { required: false })}
                       id="lastModifiedOn" name="lastModifiedOn"  label="lastModifiedOn" aria-describedby="lastModifiedOn_entry"
                       defaultValue=        {useSelector((state) => state.dataPointValueSlc.value.lastModifiedOn)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('lastModifiedBy', { required: false })}
                       id="lastModifiedBy" name="lastModifiedBy"  label="lastModifiedBy" aria-describedby="lastModifiedBy_entry"
                       defaultValue=        {useSelector((state) => state.dataPointValueSlc.value.lastModifiedBy)}
                />
            </div>
        )}

    // ****************** END HIDDEN FIELDS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={selectorDpvDrawerState}
                initialState={{open: false}}
                onClose={closeDataPointValueDrawer}
            >
                {dataPointValueForm()}

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
